import { observer } from "mobx-react";
import { useState } from "react";
import { VBox } from "./Box";
import { MenuItem } from "./MenuBar";
import {
  isSideMenuGroup,
  isSideMenuGroupExpanded,
  SideMenuEntry,
  SideMenuGroupProps,
} from "./sideMenuDomain";

const SideMenuGroup = observer(function SideMenuGroup(group: SideMenuGroupProps) {
  const [toggled, setToggled] = useState<boolean>();
  const isExpanded = isSideMenuGroupExpanded(group, toggled);
  return (
    <>
      <MenuItem
        icon={isExpanded ? "caret-down" : "caret-right"}
        text={group.text}
        onActivate={() => setToggled(!isExpanded)}
      />
      {isExpanded && (
        <VBox paddingLeft={"md"}>
          {group.items.map((item, index) => (
            <MenuItem key={index} {...item} />
          ))}
        </VBox>
      )}
    </>
  );
});

export const SideMenu = observer(function SideMenu({ entries }: { entries: SideMenuEntry[] }) {
  return (
    <VBox>
      {entries.map((entry, index) =>
        isSideMenuGroup(entry) ? (
          <SideMenuGroup key={index} {...entry} />
        ) : (
          <MenuItem key={index} {...entry} />
        ),
      )}
    </VBox>
  );
});
